module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_10_08_politics_trump-on-howard-stern_index.html_plot.e88e27b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_10_08_politics_trump-on-howard-stern_index.html_plot.png
// module id = 380
// module chunks = 0